import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000,
});

// Interceptor para agregar encabezados antes de cada petición
api.interceptors.request.use(
    (config) => {    
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        config.headers['Time-Zone'] = userTimeZone;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;